import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/tributacoes/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findTributacoes(
  empresa_cnpj,
  where = {},
  orwhere = {},
  include = ""
) {
  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });

  let query = "";
  Object.keys(where).forEach((value) => {
    query += `&where[${value}]=${where[value]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${query}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findTributacoesByNcms(
  empresa_cnpj,
  orwhere = [],
  isSameOrWhere = false
) {
  let queryOrWhere = "";
  orwhere.forEach((row, key) => {
    Object.keys(row).forEach((key) => {
      queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
        row[key]
      }`;
    });
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${queryOrWhere}`,
    "GET",
    headers
  );
}

export async function findTributacoesByIdProductOrNcms(
  empresa_cnpj,
  empresa_id,
  idProduto,
  ncm,
  cfop = "",
  ufDestino = "",
  difal = "",
  tipoDocumento = "",
  tipoDestinatario = ""
) {
  return search(
    `${path}/byproductorncm?idProduto=${idProduto}&ncm=${ncm}&cfop=${cfop}&ufDestino=${ufDestino}&difal=${difal}&tipoDocumento=${tipoDocumento}&tipoDestinatario=${tipoDestinatario}&empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}`,
    "GET",
    headers
  );
}
